// Tags the app adds on top of @bambi/api-client's spec-driven registry.
// cachePolicy.ts imports dispatchDelta.ts — it applies the delta enhancement
// before its own patches — so anything both need lives here instead.

export type CountTag =
  | 'dispatch-summary'
  | 'requested-trip-count'
  | 'will-call-count';

// Each count gets its own tag so only the mutations that can change it
// refetch it (bambi-api/README.md, "Over-invalidation").
export const COUNT_TAGS = [
  'dispatch-summary',
  'requested-trip-count',
  'will-call-count',
] as const satisfies readonly CountTag[];

// 'dispatch-summary' replaces 'dispatch' for a delta mutation; it never adds
// to the group, so it's excluded here rather than typechecking as if it did.
export type MutationCountTag = Exclude<CountTag, 'dispatch-summary'>;

// The invalidation group legacy post-process.ts applies at codegen time. An
// override replaces the generated list rather than merging into it, so an
// override that wants the group has to restate it; naming it keeps the two
// from drifting.
export const TRIP_MUTATION_TAGS = [
  'trips',
  'dispatch',
  'run-bambi-run',
] as const;
